/**
 * The layout registry — one presentational component per layout id in
 * `../nav/shellConfig.json`. All of them consume the same `ShellNavModel`.
 */
import type { ComponentType } from 'react'
import type { LayoutId } from '../nav/config'
import ClassicLayout from './classic'
import RailLayout from './rail'
import MegaMenuLayout from './megamenu'
import LaunchpadLayout from './launchpad'
import DesktopMacLayout from './desktopMac'
import FlatLayout from './flat'
import OfficeLayout from './office'
import type { ShellLayoutProps } from './types'

export const LAYOUT_COMPONENTS: Record<LayoutId, ComponentType<ShellLayoutProps>> = {
  classic: ClassicLayout,
  rail: RailLayout,
  megamenu: MegaMenuLayout,
  launchpad: LaunchpadLayout,
  'desktop-mac': DesktopMacLayout,
  flat: FlatLayout,
  office: OfficeLayout,
}

export type { ShellLayoutProps, LayoutTopBarSlots } from './types'
